import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { Input, Button, Form, Space, Select, message, Upload, Modal } from 'antd'
import { useForm } from "antd/lib/form/Form"
import { EditOutlined, PlusOutlined } from '@ant-design/icons'
import { axiosHandleEvent, baseAxiosNoInfo } from "../../tool/axios"
import { apiPrefix } from '../../js/config'
import { SelecSupplier, SelectProductType } from "../../component/common/Selects"
import E from 'wangeditor'
import Cookies from 'js-cookie'
import { Base64 } from 'js-base64'
import _ from 'lodash'

const { Option } = Select

const uploadFile = (e: { file: any, fileList: [] }) => {
    if (Array.isArray(e)) {
        return e
    }

    if (e.file.size < 30000000) {
        return e && e.fileList

    } else {
        let r = e.fileList.every((el: any) => {
            return el.size < 30000000
        })

        if (r) {
            return e.fileList
        }
    }
}

let formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 12 }
}

let tailLayout = {
    wrapperCol: { offset: 6, span: 12 }
}

export default function () {

    const { id }: { id: string | undefined } = useParams()
    const [pageTitle, setPageTitle] = useState<string>('')

    const [userData, setUserData] = useState<any>({ user_name: '', is_admin: '' })

    const [form] = useForm()
    const [loading, setLoading] = useState<boolean>(false)

    const [editor, setEditor] = useState<null | E>(null)
    const [editorVisible, setEditorVisible] = useState<boolean>(false)

    const [prevViewVisible, setPreviewVisible] = useState<boolean>(false)
    const [prevHtml, setPrevHtml] = useState<string>('')

    const [fileList, setFileList] = useState<any[]>([])

    const uploadButton = (
        <div>
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>选择图片</div>
        </div>
    )

    useEffect(() => {
        let data: any = localStorage.getItem('userData')
        let d = JSON.parse(data)
        setUserData(d)

        if (editorVisible && editor === null) {
            renderEditor((e: any) => {
                e?.txt.html(form.getFieldValue('goods_detail'))
            })
        }
    }, [editorVisible])

    useEffect(() => {
        if (id) {
            baseAxiosNoInfo('/mall_center/spu/detail', { params: { spu_id: id } }).then((res: any) => {
                if (res) {
                    form.setFieldsValue({
                        id: res.id,
                        goods_name: res.goods_name,
                        goods_type_id: res.goods_type_id,
                        goods_flags: res.goods_flags.split(','),
                        goods_desc: res.goods_desc,
                        goods_supply_id: res.goods_supply_id,
                        brand_name: res.brand_name,
                        source_name: res.source_name,
                        goods_unit: res.goods_unit,
                        is_recommend: res.is_recommend,
                        is_points_goods: res.is_points_goods,
                        goods_detail: Base64.fromBase64(res.goods_detail),
                        goods_detail_pic_url: res.goods_detail_pic_url.split(',').map((el: any) => ({ url: el, uid: el, response: { data: [el] } })),
                    })

                    setFileList(res.goods_detail_pic_url.split(',').map((el: any) => ({ url: el, uid: el, response: { data: [el] } })))
                }
            })

            setPageTitle('编辑商品')

        } else {
            setPageTitle('新增商品')
        }
    }, [])

    const renderEditor = (cb: (e: any) => void) => {
        const editor = new E('.editor')

        editor.config.uploadFileName = "files"
        editor.config.uploadImgServer = apiPrefix + '/global/upload_pic'
        editor.config.uploadImgParams = {
            fileType: '1',
            bucketType: '4'
        }

        editor.config.showLinkImg = false
        editor.config.uploadImgHeaders = {
            token: Cookies.get('token') || ''
        }

        editor.config.uploadImgHooks = {
            // 例如：服务端返回的不是 { errno: 0, data: [...] } 这种格式，可使用 customInsert
            customInsert: function (insertImgFn: any, result: any) {
                // result：即服务端返回的接口
                if (result.status === 0) {
                    insertImgFn(result.data[0])

                } else {
                    message.error(result.message)
                }
            }
        }

        editor.create()
        setEditor(editor)
        cb(editor)
    }

    const showEditModal = () => {
        setEditorVisible(true)
        editor?.txt.html(form.getFieldValue('goods_detail'))
    }

    const handleChange = ({ fileList }: { fileList: any }) => {
        setFileList(fileList)

        form.setFieldsValue({
            goods_detail_pic_url: fileList
        })
    }

    const handleEditModalOk = () => {
        let html = editor?.txt.html()
        form.setFieldsValue({ goods_detail: html })

        setEditorVisible(false)
        editor?.txt.html('')
    }

    const onFinish = (values: any) => {
        let url = id ? '/mall_center/spu/update' : '/mall_center/spu/add'

        let detailTexts = values.goods_detail.replace(/\<img/gi, '<img style="max-width:100%;height:auto;display:block;" ')
        detailTexts = detailTexts.replace(/\ style="max-width: 100%;"/gi, '')
        detailTexts = detailTexts.replace(/\ style="max-width:100%;"/gi, '')

        axiosHandleEvent.post(url, {
            spu_id: id,
            goods_name: values.goods_name,
            goods_type_id: values.goods_type_id,
            goods_flags: values.goods_flags.join(','),
            goods_desc: values.goods_desc,
            is_recommend: values.is_recommend,
            is_points_goods: values.is_points_goods,
            brand_name: values.brand_name,
            source_name: values.source_name,
            goods_unit: values.goods_unit,
            goods_supply_id: values.goods_supply_id,
            goods_detail_pic_url: (values.goods_detail_pic_url.map((el: any) => (el.response.data[0]))).join(','),
            goods_detail: Base64.toBase64(detailTexts)
        })
    }

    return (<div className="common-level2-edit">
        {/* 商城中心 -> 商品管理 -> 商品管理 -> 新增或编辑 */}
        <h2>{pageTitle}</h2>

        <div className="common-main">
            <Form {...formItemLayout} form={form} name="basic" onFinish={onFinish}>
                <Form.Item
                    label="商品名称"
                    name="goods_name"
                    rules={[{ required: true, message: '输入商品名称' }, { max: 40, message: '最多只能40个中文' }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="商品分类"
                    name="goods_type_id"
                    rules={[{ required: true, message: '选择商品分类' }]}
                >
                    <SelectProductType />
                </Form.Item>

                <Form.Item
                    label="商品标签"
                    name="goods_flags"
                    rules={[{ required: true, message: '输入商品标签' },
                    ({ getFieldValue }) => ({
                        validator(_, value) {
                            if (value.length <= 3 && value.every((el: any) => el.length <= 4)) {
                                return Promise.resolve()
                            }

                            return Promise.reject(new Error('标签最多能输入3个，每个标签不能超过4个字'));
                        }
                    })
                    ]}
                >
                    <Select mode="tags"></Select>
                </Form.Item>

                <Form.Item
                    label="商品描述"
                    name="goods_desc"
                    rules={[{ required: true, message: '输入商品描述' }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="供应商"
                    name="goods_supply_id"
                    rules={[{ required: true, message: '选择供应商' }]}
                >
                    <SelecSupplier />
                </Form.Item>

                <Form.Item
                    label="商品品牌"
                    name="brand_name"
                    rules={[{ required: true, message: '输入商品品牌' }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="商品产地"
                    name="source_name"
                    rules={[{ required: true, message: '输入商品产地' }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="商品单位"
                    name="goods_unit"
                    rules={[{ required: true, message: '输入商品单位' }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="上传图片"
                    valuePropName="fileList"
                    getValueFromEvent={uploadFile}
                    name="goods_detail_pic_url"
                    rules={[{ required: true, message: '必须上传图片，并且每张图不能大于3MB!' }]}
                >
                    <Upload
                        name="files"
                        data={{ fileType: 1, bucketType: 4 }}
                        action={apiPrefix + '/global/upload_pic'}
                        listType="picture-card"
                        onChange={handleChange}
                        beforeUpload={file => {
                            setLoading(true)

                            const isLt = file.size / 1024 / 1024 < 3;
                            if (!isLt) {
                                message.error('每张图不能大于3MB!')
                                setLoading(false)

                                return false

                            } else {
                                return true
                            }
                        }}
                    >
                        {fileList.length >= 9 ? null : uploadButton}
                    </Upload>
                </Form.Item>

                <Form.Item
                    label="是否推荐"
                    name="is_recommend"
                    rules={[{ required: true, message: '请选择是否推荐' }]}
                >
                    <Select>
                        <Option value={1} key={1}>是</Option>
                        <Option value={0} key={0}>否</Option>
                    </Select>
                </Form.Item>

                {userData.is_admin == 1 &&
                    <Form.Item
                        label="是否积分商品"
                        name="is_points_goods"
                        rules={[{ required: true, message: '请选择是否积分商品' }]}
                    >
                        <Select>
                            <Option value={0} key={0}>否</Option>
                            <Option value={1} key={1}>是</Option>
                        </Select>
                    </Form.Item>
                }

                <Form.Item label="商品详情" name="goods_detail" rules={[{ required: true, message: '必须编辑商品详情' }]}  >
                    <Space>
                        <Button onClick={() => { showEditModal() }} icon={<EditOutlined />}>编辑</Button>

                        <Button type="ghost" onClick={_ => {
                            setPrevHtml(form.getFieldValue('goods_detail'))
                            setTimeout(_ => {
                                setPreviewVisible(true)
                            }, 100)
                        }}>手机版预览</Button>
                    </Space>
                </Form.Item>

                <Form.Item {...tailLayout}>
                    <Space>
                        <Button style={{ marginRight: 12, marginBottom: 12 }} type="primary" htmlType="submit">提交</Button>
                        <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={() => { window.history.go(-1) }} >返回</Button>
                    </Space>
                </Form.Item>
            </Form>
        </div>

        {/* 商品详情编辑 */}
        <Modal visible={editorVisible} onCancel={() => { setEditorVisible(false); editor?.txt.html('') }} width="800px" onOk={handleEditModalOk}>
            <div className="editor" style={{ marginTop: 50 }}></div>
        </Modal>

        {/* 商品详情预览 */}
        <Modal visible={prevViewVisible} title="预览" footer={false} width="423px" onCancel={() => { setPreviewVisible(false); }}  >
            <div className="phone-preview" >
                <div className="phone-preview-content" dangerouslySetInnerHTML={{ __html: prevHtml }} ></div>
            </div>
        </Modal>
    </div>)
}